import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/domains';
import { GLOBAL_FORM_REPOSITORY } from '../../core';
import { GLOBAL_FORM_API } from '../data-sources';
export var GlobalFormWebRepository = /*#__PURE__*/function () {
  function GlobalFormWebRepository(globalFormApi) {
    _classCallCheck(this, GlobalFormWebRepository);

    this.globalFormApi = globalFormApi;
  }

  _createClass(GlobalFormWebRepository, [{
    key: "findMany",
    value: function () {
      var _findMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.globalFormApi.findMany(query);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                result = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(result));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findMany(_x) {
        return _findMany.apply(this, arguments);
      }

      return findMany;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, globalFormValue;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.globalFormApi.create(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                globalFormValue = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(globalFormValue));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.globalFormApi.update(input);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "getGroupByCategory",
    value: function () {
      var _getGroupByCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var responseOrError, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.globalFormApi.getGroupByCategory(input);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", mappingResultError(responseOrError));

              case 5:
                result = responseOrError.getValue();
                return _context4.abrupt("return", Result.ok(result));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getGroupByCategory(_x4) {
        return _getGroupByCategory.apply(this, arguments);
      }

      return getGroupByCategory;
    }()
  }, {
    key: "convertToNormalForm",
    value: function () {
      var _convertToNormalForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.globalFormApi.convertToNormalForm(id);

              case 2:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context5.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function convertToNormalForm(_x5) {
        return _convertToNormalForm.apply(this, arguments);
      }

      return convertToNormalForm;
    }()
  }]);

  return GlobalFormWebRepository;
}();
export var globalFormWebRepositoryProvider = {
  provide: GLOBAL_FORM_REPOSITORY,
  useFactory: function useFactory(globalFormApi) {
    return new GlobalFormWebRepository(globalFormApi);
  },
  inject: [GLOBAL_FORM_API]
};